import { combineReducers } from 'redux'
import loginReducer from './login'
import bookingReducer from './booking'
import globalReducers from './globalReducers'
import mainReducer from './mainReducer'

export default combineReducers({
	loginReducer,
	bookingReducer,
	globalReducers,
	mainReducer
})
